<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item active" aria-current="page" v-if="FormData && FormData.Form">{{ FormData.Form.Name }}
        </li>
      </ol>
    </div>

    <div class="wrapper form" v-if="FormData && FormData.Form">
      <section class="form_main">
        <div class="container">
          <form id="frmFormRender" class="box">
            <input id="FId" name="FId" type="hidden" :value="FormData.Form.FId" />
            <input id="serializeData" name="serializeData" type="hidden" />
            <h1>{{ FormData.Form.Name }}</h1>
            <div class="text" v-if="FormData.Form.HeaderContent" v-html="FormData.Form.HeaderContent">
            </div>
            <hr v-if="FormData.Form.HeaderContent" />
            <div id="divForm"></div>
            <hr />
            <div class="btn_box">
              <button type="submit" class="btn_send">送出</button>
            </div>
          </form>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Form",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      FormData: {},
      fbRender: null,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Form",
        {
          params: {
            FId: this.$route.params.FId,
            lang: $cookies.get("is_site_lang")
          },
        }
      )
      .then((response) => {
        this.FormData = response.data;
        let that = this;
        Promise.all(Array.from(document.images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => img.addEventListener('load', resolve));
        })).then(() => {
          setTimeout(() => {
            that.fbRender = $('#divForm').formRender({
              dataType: 'json',
              formData: that.FormData.Form.Serialize,
              i18n: {
                locale: 'zh-TW',
                location: '/plugins/form-builder/',
                extension: '.lang',
                override: {
                  'zh-TW': {
                    close: '收起編輯區',
                    required: '必填',
                    label: '標題',
                    labelEmpty: '標題欄位不能是空白的',
                    min: '最小值',
                    max: '最大值',
                    placeholder: '提示文字',
                    password: '密碼',
                    email: '電子郵件地址',
                    checkboxGroup: '多選選單',
                    radioGroup: '單選選單',
                    select: '下拉選單',
                    number: '數字欄位',
                    fileUpload: '檔案上傳欄位',
                    header: '標題',
                    paragraph: '文字段落(僅顯示)',
                    remove: '刪除',
                    enableOther: '啟用「其它」選項',
                    enableOtherMsg: '使用者可自行輸入選項文字',/*'允許使用者填寫自定義選項',*/
                    inline: '單行顯示',
                    inlineDesc: '以單行顯示項目內容',
                    value: '預設值',
                    rows: '預設行數',
                    description: '說明',
                    maxlength: '字數設定',
                  }
                }
              }
            });

            $("#divForm select").each(function () {
              var $this = $(this);
              if ($this.data('relatedto')) {
                // 設定一次預設顯示
                $('#' + $this.attr('id') + ' option')
                  .hide()
                  .filter('[value^="' + $('#' + $this.data('relatedto')).val() + ':"]')
                  .show();
                if ($('#' + $this.attr('id') + ' option[value^="' + $('#' + $this.data('relatedto')).val() + ':"]').length) {
                  $('#' + $this.attr('id') + ' option[value^="' + $('#' + $this.data('relatedto')).val() + ':"]').first().prop('selected', true);
                }
                // 再處理變動時的顯示
                $('#' + $this.data('relatedto')).change(function () {
                  $('#' + $this.attr('id') + ' option')
                    .hide()
                    .filter('[value^="' + $(this).val() + ':"]')
                    .show();
                  if ($('#' + $this.attr('id') + ' option[value^="' + $(this).val() + ':"]').length) {
                    $('#' + $this.attr('id') + ' option[value^="' + $(this).val() + ':"]').first().prop('selected', true);
                  }
                });
              }
            });

            $("#divForm").find(":file").each(function () {
              var fileId = $(this).attr('id');
              $(this).parent().append("<input type='hidden' id='" + fileId + "_fileUrl' name='" + fileId + "_fileUrl' value=''>");
              $(this).on("change", function () {
                var file = this.files[0];
                if (this.files && file) {
                  var re = /(\.png|\.jpg|\.bmp|\.gif|\.doc|\.docx|\.xls|\.xlsx|\.ppt|\.pptx|\.odt|\.ods|\.odp|\.pdf|\.zip|\.rar|\.7z|\.avi|\.mp4|\.wmv|\.mov|\.flv|\.csv)$/i;
                  if (!re.exec(file.name)) {
                    alert("檔案類型錯誤無法上傳");
                    $(this).val('');
                  } else {
                    var chunkSize = 50 * 1024 * 1024;
                    var totalChunks = Math.ceil(file.size / chunkSize);
                    var currentChunk = 0;
                    function uploadChunk() {
                      var start = currentChunk * chunkSize;
                      var end = Math.min(file.size, start + chunkSize);
                      var chunk = file.slice(start, end);
                      var formData = new FormData();
                      formData.append('file', chunk);
                      formData.append('fileName', file.name);
                      formData.append('totalChunks', totalChunks);
                      formData.append('currentChunk', currentChunk);
                      $.ajax({
                        type: 'post',
                        url: that.$store.state.src + that.$store.state.subDirectory + "/Html/_FileUpload",
                        contentType: false,
                        processData: false,
                        data: formData,
                        xhr: function () {
                          var myXhr = $.ajaxSettings.xhr();
                          if (myXhr.upload) {
                            myXhr.upload.addEventListener('progress', function (evt) {
                              if (evt.lengthComputable) {
                                var percent = ((currentChunk + evt.loaded / evt.total) / totalChunks) * 100;
                                $('#progress_msg').html(Math.floor(percent) + "%");
                              }
                            }, false);
                          }
                          return myXhr;
                        },
                        success: function (result) {
                          if (result.ok) {
                            currentChunk++;
                            if (currentChunk < totalChunks) {
                              uploadChunk();
                            } else {
                              Swal.close();
                              $('#' + fileId + '_fileUrl').val(result.FileUrl);
                            }
                          } else {
                            handleError(result.error);
                          }
                        },
                        error: function (xhr, status) {
                          handleError('檔案上傳失敗, 請稍後再試一次');
                        }
                      });
                    }

                    function handleError(message) {
                      $('#' + fileId + '_fileUrl').val('');
                      $('#' + fileId).val('');
                      Swal.fire({
                        icon: "error",
                        title: "錯誤",
                        text: message,
                        confirmButtonText: "確　　認"
                      });
                    }

                    Swal.fire({
                      title: "上傳中",
                      html: '<span id="progress_msg">請稍候...</span>',
                      didOpen: function () {
                        Swal.showLoading();
                        uploadChunk();
                      },
                      showConfirmButton: false,
                      allowOutsideClick: false
                    });
                  }
                }
              });
            });

            $("#frmFormRender").parsley().on("field:validated", function () {
              var e = 0 === $(".parsley-error").length;
              $(".alert-info").toggleClass("d-none", !e), $(".alert-warning").toggleClass("d-none", e)
            }).on("form:submit", function () {
              $("#serializeData").val(JSON.stringify(that.fbRender.userData))
              that.sendForm();
              return false;
            })
          }, 500);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
  },
  updated: function () {
  },
  methods: {
    async getRecaptchaToken() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('form');
      } catch {
        Swal.fire({
          title: "錯誤",
          text: "請確認網路環境後再試一次（RG）",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return null;
      }
    },
    async sendForm() {
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/_SendForm",
        type: "post",
        data:
          $('#frmFormRender').serialize() +
          "&recaptchaToken=" +
          encodeURIComponent(recaptchaToken),
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Swal.fire({
              title: "成功",
              text: "已成功送出, 感謝您的填寫!",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                location.reload();
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
  },
};
</script>
